import { withPluginApi } from "discourse/lib/plugin-api";
import Site from "discourse/models/site";

function getSiteLink(user) {
  const siteUserFields = Site.current().user_fields;
  if (!siteUserFields || siteUserFields.length === 0) {
    return null;
  }

  const externalUserIdField = siteUserFields.find(
    (f) => f.name === "CodeChef Profile"
  );
  if (!externalUserIdField) {
    return null;
  }

  const userFieldId = externalUserIdField.id;
  const userFields = user.user_fields;
  if (userFields && userFields[userFieldId]) {
    const username = userFields[userFieldId];
    const url = "https://codechef.com/users/" + username;
    const link =
      "<a href='" + url + "' target='_blank'>" + username + "</a>";
    return { link, name: externalUserIdField.name };
  }

  return null;
}

export default {
  name: "site-link",
  initialize() {
    withPluginApi("0.8.31", (api) => {
      api.registerConnectorClass("user-card-metadata", "site-link", {
        setupComponent(args, component) {
          component.set("siteLink", getSiteLink(args.user));
        },
      });

      api.registerConnectorClass("user-profile-primary", "site-link", {
        setupComponent(args, component) {
          component.set("siteLink", getSiteLink(args.model));
        },
      });
    });
  },
};

import deprecated_gjYVqPLMxe from "discourse/lib/deprecated";
deprecated_gjYVqPLMxe(
  "The file 'discourse/initializers/site-link.js.es6' uses the deprecated `.js.es6` extension. Use `.js` instead.",
  {
    id: "discourse.es6-extension",
    url: "https://meta.discourse.org/t/398894",
  }
);
